export const breadcrumb = {
  title: 'SMS atau pesan',

  mailing: {
    index: 'Daftar pesan',
    create: 'Buat pesan'
  },

  message: {
    title: 'Pesan',
    index: 'Pesan masuk',
    setting: 'Konfigurasi Pesan masuk',

    tab: {
      index: 'Pesan masuk',
      setting: 'Settings'
    }
  },

  template: {
    index: 'Templates'
  },

  sender: {
    index: 'Senders'
  }
};
